import SideNavigationProps from "!!extract-react-types-loader!../../../../../../packages/design-system/side-navigation/src/components/SideNavigation";
import HeaderProps from "!!extract-react-types-loader!../../../../../../packages/design-system/side-navigation/src/components/Header";
import FooterProps from "!!extract-react-types-loader!../../../../../../packages/design-system/side-navigation/docs/ert/footer";
import NavigationContentProps from "!!extract-react-types-loader!../../../../../../packages/design-system/side-navigation/src/components/NavigationContent";
import NestableNavigationContentProps from "!!extract-react-types-loader!../../../../../../packages/design-system/side-navigation/src/components/NestableNavigationContent";
import SectionProps from "!!extract-react-types-loader!../../../../../../packages/design-system/side-navigation/src/components/Section";
import * as React from 'react';
export default {
  SideNavigationProps,
  HeaderProps,
  FooterProps,
  NavigationContentProps,
  NestableNavigationContentProps,
  SectionProps,
  React
};